import {
  createFileRoute,
} from '@tanstack/react-router';

import {
  TabLayout,
} from '#components/layouts/TabLayout';
import {
  TabsGroup,
  type TabProps,
} from '#src/components/ui/nav/TabsGroup';

export const Route = createFileRoute(
  '/_app/_authenticated/mydigitalworkers/scout/_scoutLayout',
)({
  component: RouteComponent,
  beforeLoad: () => {
    const adminLinks: TabProps[] = [
      {
        label: 'Settings',
        link: {
          from: Route.fullPath,
          to: '/mydigitalworkers/scout/settings',
        },
        hidden: (context) => {
          if (context?.auth?.user?.profile?.groups) {
            return !((context.auth.user.profile.groups as string[]).includes('client-admin'));
          }
          return false;
        },
      },
    ];
    const defaultLinks: TabProps[] = [
      {
        label: 'Requests',
        link: {
          from: Route.fullPath,
          to: '/mydigitalworkers/scout/requests',
        },
      },
      {
        label: 'Clients',
        link: {
          from: Route.fullPath,
          to: '/mydigitalworkers/scout/clients',
        },
      },
    ];
    return {
      crumb: {
        label: 'Scout',
        href: '/requests',
      },
      header: (
        <>
          <TabsGroup
            tabs={ defaultLinks.concat(adminLinks) }
            defaultTabIndex={ 0 }
          />
        </>
      ),
    };
  },
});

function RouteComponent(): React.ReactNode {
  return (
    <>
      <TabLayout />
    </>
  );
}
